import React from 'react';
import { testimonials } from '../../mock/mock';
import { Star, Quote } from 'lucide-react';

export default function Testimonials() {
  return (
    <section id="reviews" className="py-24 lg:py-32 bg-gradient-to-b from-[#F6EAE0] to-[#FBF7F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="section-eyebrow">Words from real couples</p>
          <h2 className="font-serif text-4xl lg:text-5xl mt-3 text-[#2A2A2A] leading-tight">
            Real couples. Real <span className="italic text-[#7B2C3B]">happy tears</span>.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-5 text-[#B8896C]">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-[#B8896C]" />
            ))}
            <span className="text-sm text-[#2A2A2A] ml-2">Verified five-star reviews</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="soft-card rounded-2xl p-7 hover:translate-y-[-3px] transition-transform relative"
            >
              <Quote className="w-7 h-7 text-[#F4D6CE] absolute top-5 right-5" />
              <div className="flex items-center gap-1 text-[#B8896C] mb-4">
                {[...Array(t.rating)].map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-[#B8896C]" />
                ))}
              </div>
              <p className="text-[#2A2A2A] leading-relaxed text-[15px] mb-5 italic font-serif">
                “{t.text}”
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-[#EFE3D8]">
                <div className="w-9 h-9 rounded-full bg-[#F4D6CE] flex items-center justify-center text-[#7B2C3B] font-serif text-sm font-semibold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-[#2A2A2A]">{t.name}</p>
                  <p className="text-xs text-[#6A6A6A]">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
